function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "Success_svg__18_a",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#4EDC9F"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#1DC463"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "url(#Success_svg__18_a)",
  fillRule: "evenodd",
  d: "M18 34C9.163 34 2 26.837 2 18S9.163 2 18 2s16 7.163 16 16-7.163 16-16 16zm6.585-23.604a1.38 1.38 0 00-.158.175l-9.233 12.26-3.492-4.5c-.454-.604-1.351-.752-2.003-.331a1.315 1.315 0 00-.312 1.926l4.031 5.216c.686.91 2.037 1.131 3.017.495.209-.135.39-.302.535-.495l9.773-12.977a1.315 1.315 0 00-.124-1.78 1.52 1.52 0 00-2.034.01z",
  transform: "translate(-2 -2)"
});

var SvgSuccess = function SvgSuccess(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _ref, _ref2);
};

export default SvgSuccess;